import axios from 'axios'

export default{
    namespaced: true,

    state: {
        reportPeriods: [],        
    },

    getters: {
        getReportPeriods(state){
            return state.reportPeriods;
        }
    },

    mutations: {
        setReportPeriods(state, value){
            state.reportPeriods = value;
        }
    },

    actions: {
        getReportTerms (contex, $id) {
            let url = '/api/report-card-terms/' + $id;           
            return axios.get(url);
        },        
    },
}